module.exports = __webpack_public_path__ + "static/media/platform@3x.68c25050.png";